(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4043],{

/***/ 79307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ defaultHead; }
/* harmony export */ });
var defaultHead = {
    title: "Hire Digital",
    meta: [
        {
            name: "image",
            content: "http://cdn.hiredigital.com/open-graph/hd/image_opt.jpg"
        },
        {
            name: "description",
            content: "Scale your content and digital marketing with Hire Digital's exclusive talent network. Rigorously screened for your most important projects."
        }, 
    ],
    link: []
};


/***/ }),

/***/ 93711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ generateSchema; },
/* harmony export */   "Hk": function() { return /* binding */ generateDev; },
/* harmony export */   "_M": function() { return /* binding */ cleanPageHead; },
/* harmony export */   "fB": function() { return /* binding */ convertPropsToHeadElements; },
/* harmony export */   "ok": function() { return /* binding */ generateSocial; },
/* harmony export */   "t": function() { return /* binding */ generateFaqSchema; },
/* harmony export */   "tC": function() { return /* binding */ getMetaContent; }
/* harmony export */ });
/* unused harmony export generateProd */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15963);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70169);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);




var convertPropsToHeadElements = function(attributes) {
    if (!attributes) return null;
    var attributeKeys = Object.keys(attributes);
    var helmetAttributes = [];
    for(var i = 0; i < attributeKeys.length; i++){
        var Elem = attributeKeys[i];
        var data = attributes[attributeKeys[i]];
        if (typeof data === "string" || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(data, String)) {
            helmetAttributes.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Elem, {
                children: data
            }, attributeKeys[i]));
        } else if (Array.isArray(data)) {
            for(var j = 0; j < data.length; j++){
                var arrDataObj = data[j];
                helmetAttributes.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Elem, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, arrDataObj), "".concat(attributeKeys[i], "-").concat(arrDataObj["name"] || arrDataObj["property"])));
            }
        }
    }
    return helmetAttributes;
};
var cleanPageHead = function(pageHead) {
    var newPageHead = pageHead;
    if (!newPageHead) return null;
    if (newPageHead.meta === null) {
        newPageHead.meta = [];
    }
    if (newPageHead.link === null) {
        newPageHead.link = [];
    }
    return newPageHead;
};
var getMetaContent = function(head, name) {
    if (!head || !head.meta) {
        return null;
    }
    if (Array.isArray(head.meta)) {
        var metaObj = head.meta.find(function(meta) {
            return meta.name === name || meta.property === name;
        });
        if (metaObj) {
            return metaObj.content;
        }
    } else if (head.meta.name === name || head.meta.property === name) {
        return head.meta.content;
    }
    return null;
};
var generateSchema = function(param, postSchema, schemaFaq) {
    var title = param.title, image = param.image, description = param.description, url = param.url, isPost = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var data = [
        {
            "@context": "http://schema.org",
            "@type": "WebSite",
            url: url,
            name: title,
            alternateName: "Hire Digital"
        }, 
    ];
    if (isPost) {
        data.push({
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
                {
                    "@type": "ListItem",
                    position: 1,
                    item: {
                        "@id": url,
                        name: title,
                        image: image
                    }
                }, 
            ]
        }, {
            "@context": "http://schema.org",
            "@type": "BlogPosting",
            url: url,
            name: title,
            alternateName: "Hire Digital",
            headline: title,
            image: {
                "@type": "ImageObject",
                url: image
            },
            description: description,
            mainEntityOfPage: {
                "@type": "WebPage",
                "@id": url
            },
            author: {
                "@type": "Person",
                name: (postSchema === null || postSchema === void 0 ? void 0 : postSchema.author) || "Hire Digital Editorial"
            },
            publisher: {
                "@type": "Organization",
                name: (postSchema === null || postSchema === void 0 ? void 0 : postSchema.publisher) || "Hire Digital",
                logo: {
                    "@type": "ImageObject",
                    url: "http://cdn.hiredigital.com/email/hd-logo-small.png"
                }
            },
            datePublished: postSchema === null || postSchema === void 0 ? void 0 : postSchema.datePublished,
            dateModified: postSchema === null || postSchema === void 0 ? void 0 : postSchema.dateModified
        }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, schemaFaq));
    } else {
        data.push({
            "@context": "http://schema.org",
            "@type": "WebPage",
            url: url,
            name: title,
            alternateName: "Hire Digital",
            image: image,
            description: description
        }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, schemaFaq));
    }
    return JSON.stringify(data);
};
var generateSocial = function(param) {
    var title = param.title, image = param.image, description = param.description, url = param.url, isPost = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        meta: [
            {
                name: "twitter:title",
                content: title
            },
            {
                name: "twitter:description",
                content: description
            },
            image ? {
                property: "twitter:image",
                content: image
            } : {},
            {
                name: "twitter:card",
                content: "summary_large_image"
            },
            {
                name: "twitter:site",
                content: "@hiredigital1"
            },
            {
                name: "twitter:creator",
                content: "@hiredigital1"
            },
            {
                property: "og:title",
                content: title
            },
            {
                property: "og:description",
                content: description
            },
            image ? {
                property: "og:image",
                content: image
            } : {},
            {
                property: "og:url",
                content: url
            },
            {
                property: "og:type",
                content: isPost ? "article" : "website"
            }, 
        ]
    };
};
var generateProd = function() {
    return {
        meta: [
            {
                property: "fb:app_id",
                content: "XXXXXXXXXXXXXX"
            }
        ]
    };
};
var generateDev = function() {
    return {
        meta: [
            {
                name: "robots",
                content: "noindex"
            }
        ]
    };
};
var generateFaqSchema = function(data) {
    if (!data) return;
    var mainEntity = [];
    var schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: []
    };
    data === null || data === void 0 ? void 0 : data.map(function(param) {
        var answer = param.answer, question = param.question;
        mainEntity.push({
            "@type": "Question",
            name: removeExtraSpace(removeLineBreaks(question)),
            acceptedAnswer: {
                "@type": "Answer",
                text: removeExtraSpace(removeLineBreaks(answer))
            }
        });
    });
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, schema), {
        mainEntity: mainEntity
    });
};
var removeLineBreaks = function(t) {
    return t === null || t === void 0 ? void 0 : t.replace(/(\r\n|\n|\r|\\)/gm, "");
};
var removeExtraSpace = function(t) {
    return t === null || t === void 0 ? void 0 : t.replace(/\s\s+/g, " ");
};


/***/ }),

/***/ 305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);








// Custom Link component that offers backwards compatibility with GatsbyJS Link component
var CustomLink = function(_param) {
    var to = _param.to, href = _param.href, as = _param.as, _shallow = _param.shallow, shallow = _shallow === void 0 ? false : _shallow, children = _param.children, className = _param.className, activeClassName = _param.activeClassName, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "to",
        "href",
        "as",
        "shallow",
        "children",
        "className",
        "activeClassName"
    ]);
    var h = href || to;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: h,
        as: as,
        shallow: shallow,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, router.asPath === h && activeClassName)
        }, props), {
            children: children
        }))
    });
};
CustomLink.propTypes = {
    to: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
    ]),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    activeClassName: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLink);


/***/ }),

/***/ 92256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports Parent, heroStyles */
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26067);
/* harmony import */ var _Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var Parent = {
    MAIN: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main),
    NEW_ENTERPRISE: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().newEnterprise),
    ENTERPRISE_COMPANY: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().enterpriseCompany),
    VERTICAL: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().vertical),
    TALENT: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().talent),
    CONTACT: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().contact),
    LOGIN: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().login),
    REGISTER: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().register),
    DOWNLOADS: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().downloads),
    NEW_HERO: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().newHero)
};
var heroStyles = (/* unused pure expression or super */ null && (Styles));
var Hero = function(_param) {
    var square = _param.square, angle = _param.angle, style = _param.style, parent = _param.parent, containerClass = _param.containerClass, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "square",
        "angle",
        "style",
        "parent",
        "containerClass",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(parent, containerClass),
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: square && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().waveContainer),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().angleLarge)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().angleLarge1)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().angleRightLarge)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().angleRightLarge1)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: angle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().waveContainer),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().rightAngleLarge)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().rightAngleLarge1)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().rightAngleLarge2)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().itemContainer),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default().rightAngleLarge3)
                            })
                        })
                    ]
                })
            }),
            children
        ]
    });
};
Hero.Page = Parent;
Hero.Styles = (_Hero_module_scss__WEBPACK_IMPORTED_MODULE_3___default());
Hero.propTypes = {
    parent: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
    containerClass: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    angle: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};
/* harmony default export */ __webpack_exports__["ZP"] = (Hero);


/***/ }),

/***/ 61522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _Styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64781);
/* harmony import */ var _Styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22974);
/* harmony import */ var _hiredigital_ui_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90645);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);









var HeroButton = function(_param) {
    var className = _param.className, to = _param.to, href = _param.href, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "to",
        "href",
        "children"
    ]);
    var Component;
    if (to || href) {
        Component = _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP;
    } else {
        Component = _hiredigital_ui_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button), className),
        href: to || href || undefined
    }, props), {
        children: children
    }));
};
HeroButton.Type = {
    WHITE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Type.WHITE */ .ZP.Type.WHITE,
    BLUE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Type.BLUE */ .ZP.Type.BLUE,
    DARKBLUE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Type.DARKBLUE */ .ZP.Type.DARKBLUE,
    BLUE_OUTLINE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Type.BLUE_OUTLINE */ .ZP.Type.BLUE_OUTLINE,
    WHITE_OUTLINE: _hiredigital_ui_Button_NextButtonLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Type.WHITE_OUTLINE */ .ZP.Type.WHITE_OUTLINE
};
HeroButton.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    to: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroButton);


/***/ }),

/***/ 17839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContainerType */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65811);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Section_module_scss__WEBPACK_IMPORTED_MODULE_2__);







var ContainerType = {
    CIRCLE: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerCircle),
    BLUE: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerBlue),
    LIGHTBLUE: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerLightblue),
    DARKBLUE: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerDarkblue),
    ENTERPRISE_SPLIT: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerEnterpriseSplit),
    ENTERPRISE_FULL: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerEnterpriseFull),
    PROFESSIONAL_SPLIT: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerProfessionalSplit),
    PRIMARY_BLUE: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerPrimaryblue),
    LIGHTBLUE_GRADIENT: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerLightblueGradient),
    WHITE: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerPlainWhite)
};
var SectionContainer = function(_param) {
    var children = _param.children, className = _param.className, style = _param.style, anchor = _param.anchor, type = _param.type, split = _param.split, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "style",
        "anchor",
        "type",
        "split"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), split && (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().splitContainer), type, className),
        style: style
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().anchor),
                id: anchor
            }),
            children
        ]
    }));
};
SectionContainer.Type = ContainerType;
SectionContainer.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    anchor: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    split: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool)
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionContainer);


/***/ }),

/***/ 80863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65811);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10966);





var Section = function(param) {
    var children = param.children, className = param.className, style = param.style, title = param.title, subtitle = param.subtitle, _textColor = param.textColor, textColor = _textColor === void 0 ? undefined : _textColor, _textType = param.textType, textType = _textType === void 0 ? undefined : _textType, titleClass = param.titleClass, subTitleClass = param.subTitleClass;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section), className),
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                element: "h2",
                size: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Size.SUBHEADLINE_LARGE */ .Z.Size.SUBHEADLINE_LARGE,
                color: textColor,
                type: textType,
                className: titleClass,
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                element: "p",
                size: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Size.SECTION_BODY */ .Z.Size.SECTION_BODY,
                color: textColor,
                type: textType,
                className: subTitleClass,
                children: subtitle
            }),
            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addMargin),
                children: children
            }) : children
        ]
    });
};
Section.Color = _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Color */ .Z.Color;
Section.Type = _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type */ .Z.Type;
Section.Styles = (_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default());
Section.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Section);


/***/ }),

/***/ 50943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* reexport safe */ _Section__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "S": function() { return /* reexport safe */ _Container__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80863);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17839);





/***/ }),

/***/ 41551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UserMasonry_UserMasonry; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/UserMasonry/UserMasonry.module.scss
var UserMasonry_module = __webpack_require__(71987);
var UserMasonry_module_default = /*#__PURE__*/__webpack_require__.n(UserMasonry_module);
;// CONCATENATED MODULE: ./src/components/UserMasonry/MasonryContainer.jsx







var MasonryType = {
    STANDARD: 0,
    TALENT: 1,
    COMPANY: 2
};
var Item = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7934).then(__webpack_require__.bind(__webpack_require__, 27934));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27934)
            ];
        }
    },
    ssr: false
});
var TalentItem = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5657).then(__webpack_require__.bind(__webpack_require__, 45657));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45657)
            ];
        }
    },
    ssr: false
});
var Container = function(param) {
    var items = param.items, isMobile = param.isMobile, type = param.type, bottom = param.bottom, className = param.className, CustomTile = param.specialTile;
    var newItems = (0,_to_consumable_array/* default */.Z)(items);
    var ref = (0,react.useState)(newItems), itemList = ref[0], setItemList = ref[1];
    var ref1 = (0,react.useState)(false), mobile = ref1[0], setMobile = ref1[1];
    (0,react.useEffect)(function() {
        setMobile(isMobile);
    }, [
        isMobile
    ]);
    (0,react.useEffect)(function() {
        if (CustomTile && newItems.includes(CustomTile) === false) {
            newItems.splice(1, 0, CustomTile);
            setItemList((0,_to_consumable_array/* default */.Z)(newItems));
        }
    }, [
        CustomTile
    ]);
    var ItemTile = type === MasonryType.STANDARD ? Item : TalentItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(mobile ? (UserMasonry_module_default()).scroll : (UserMasonry_module_default()).portfolioList, type === MasonryType.TALENT && (UserMasonry_module_default()).talentPortfolioList, type === MasonryType.COMPANY && (UserMasonry_module_default()).companyPortfolioList),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((UserMasonry_module_default()).spacer, CustomTile && (UserMasonry_module_default()).smallSpacer)
                    }),
                    itemList.map(function(item, index) {
                        return (item === null || item === void 0 ? void 0 : item.uuid) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTile, {
                            item: item
                        }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTile, {}, index);
                    }),
                    mobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            flex: "0 0 1px"
                        }
                    })
                ]
            }),
            mobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (UserMasonry_module_default()).removeScroll
            })
        ]
    });
};
Container.propTypes = {
    items: prop_types_default().arrayOf((prop_types_default()).object),
    isMobile: (prop_types_default()).bool,
    bottom: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
Container.MasonryType = MasonryType;
/* harmony default export */ var MasonryContainer = (Container);

;// CONCATENATED MODULE: ./src/components/UserMasonry/UserMasonry.jsx






var UserMasonry = function(param) {
    var users = param.users, bottom = param.bottom, _type = param.type, type = _type === void 0 ? MasonryContainer.MasonryType.STANDARD : _type, specialTile = param.specialTile, className = param.className;
    var setSliderType = /**
   * Define if isMobile is mobile
   */ function setSliderType() {
        if (true) {
            if (window.innerWidth < 599) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        }
    };
    var ref = (0,react.useState)(false), isMobile = ref[0], setIsMobile = ref[1];
    (0,react.useEffect)(function() {
        window.addEventListener("resize", setSliderType);
        setSliderType();
        return function removeListener() {
            window.removeEventListener("resize", setSliderType);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((UserMasonry_module_default()).container, className, type === MasonryContainer.MasonryType.COMPANY && (UserMasonry_module_default()).companyContainer),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MasonryContainer, {
            items: users,
            type: type,
            isMobile: isMobile,
            bottom: bottom,
            specialTile: specialTile
        })
    });
};
UserMasonry.propTypes = {
    users: (prop_types_default()).array,
    bottom: (prop_types_default()).bool,
    type: (prop_types_default()).number
};
UserMasonry.MasonryType = MasonryContainer.MasonryType;
/* harmony default export */ var UserMasonry_UserMasonry = (UserMasonry);


/***/ }),

/***/ 77040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Loader_Loader_jsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64839);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67999);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Button_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);









var Type = {
    BLUE: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().blue),
    DARKBLUE: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().darkblue),
    GRAY: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().gray),
    LIGHT_GRAY: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().lightGray),
    WHITE: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().white),
    WHITE_OUTLINE: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().whiteOutline),
    WHITE_BLUE_OUTLINE: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().whiteBlueOutline),
    BLUE_OUTLINE: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().blueOutline),
    RED_OUTLINE: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().redOutline)
};
var lightTypes = [
    Type.WHITE,
    Type.WHITE_BLUE_OUTLINE,
    Type.BLUE_OUTLINE,
    Type.RED_OUTLINE,
    Type.LIGHT_GRAY, 
];
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var type = _param.type, size = _param.size, className = _param.className, children = _param.children, content = _param.content, disabled = _param.disabled, isLoading = _param.isLoading, Elem = _param.element, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "type",
        "size",
        "className",
        "children",
        "content",
        "disabled",
        "isLoading",
        "element"
    ]);
    var isLight = lightTypes.filter(function(l) {
        return l === type;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Elem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        type: "button",
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btn), className, type, size, isLoading && (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isLoadingBtn)),
        disabled: disabled
    }, props), {
        children: [
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader_Loader_jsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                className: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().loader),
                color: (isLight === null || isLight === void 0 ? void 0 : isLight.length) ? _Loader_Loader_jsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Color.BLUE */ .Z.Color.BLUE : _Loader_Loader_jsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Color.WHITE */ .Z.Color.WHITE,
                size: _Loader_Loader_jsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Size.SMALL */ .Z.Size.SMALL
            }),
            content || children
        ]
    }));
});
Button.Type = Type;
Button.Size = {
    FULLWIDTH: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().fullwidth),
    HALFWIDTH: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().halfwidth),
    FULLWIDTH_LARGE: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().fullwidthLarge),
    LARGE: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default().large)
};
Button.Styles = (_Button_module_scss__WEBPACK_IMPORTED_MODULE_4___default());
Button.defaultProps = {
    element: "button"
};
Button.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node),
    content: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    disabled: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    isLoading: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    asLink: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool)
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 22974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ NextButtonLink; }
});

// UNUSED EXPORTS: ButtonSize, ButtonType

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/NextLink.jsx








// Custom Link component that offers backwards compatibility with GatsbyJS Link component
var CustomLink = function(_param) {
    var to = _param.to, href = _param.href, as = _param.as, _shallow = _param.shallow, shallow = _shallow === void 0 ? false : _shallow, children = _param.children, className = _param.className, activeClassName = _param.activeClassName, props = (0,_object_without_properties/* default */.Z)(_param, [
        "to",
        "href",
        "as",
        "shallow",
        "children",
        "className",
        "activeClassName"
    ]);
    var h = href || to;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: h,
        as: as,
        shallow: shallow,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: classnames_default()(className, router.asPath === h && activeClassName)
        }, props), {
            children: children
        }))
    });
};
CustomLink.propTypes = {
    to: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    children: (prop_types_default()).node,
    className: (prop_types_default()).string,
    activeClassName: (prop_types_default()).string
};
/* harmony default export */ var NextLink = (CustomLink);

// EXTERNAL MODULE: ../@hiredigital/ui/src/Button/Button.module.scss
var Button_module = __webpack_require__(67999);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Button/NextButtonLink.jsx




// Note that this is a nextjs-only component as it requires the Link component





var ButtonType = {
    BLUE: (Button_module_default()).blue,
    NEW_BLUE: (Button_module_default()).blue,
    DARKBLUE: (Button_module_default()).darkblue,
    WHITE: (Button_module_default()).white,
    WHITE_BLUE_OUTLINE: (Button_module_default()).whiteBlueOutline,
    BLUE_OUTLINE: (Button_module_default()).blueOutline,
    NEW_BLUE_OUTLINE: (Button_module_default()).newBlueOutline,
    DARKBLUE_OUTLINE: (Button_module_default()).darkBlueOutline,
    ENTERPRISE: (Button_module_default()).enterprise,
    WHITE_OUTLINE: (Button_module_default()).whiteOutline
};
var ButtonSize = {
    FULLWIDTH: (Button_module_default()).fullwidth,
    FULLWIDTH_LARGE: (Button_module_default()).fullwidthLarge,
    LARGE: (Button_module_default()).large
};
var ButtonLink = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var type = _param.type, size = _param.size, to = _param.to, href = _param.href, className = _param.className, title = _param.title, children = _param.children, content = _param.content, as = _param.as, external = _param.external, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "type",
        "size",
        "to",
        "href",
        "className",
        "title",
        "children",
        "content",
        "as",
        "external"
    ]);
    var parentClass = classnames_default()((Button_module_default()).btn, type, size, className);
    var linkTitle = title ? title : "";
    return external ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: parentClass,
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        title: linkTitle
    }, restProps), {
        children: content || children
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: as,
        href: href,
        className: parentClass,
        title: linkTitle
    }, restProps), {
        children: content || children
    }));
});
ButtonLink.Type = ButtonType;
ButtonLink.Size = ButtonSize;
ButtonLink.Styles = (Button_module_default());
ButtonLink.propTypes = {
    type: (prop_types_default()).string,
    size: (prop_types_default()).string,
    to: (prop_types_default()).string,
    href: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    className: (prop_types_default()).string,
    title: (prop_types_default()).string,
    children: (prop_types_default()).node,
    content: (prop_types_default()).string
};
/* harmony default export */ var NextButtonLink = (ButtonLink);


/***/ }),

/***/ 90645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77040);

/* harmony default export */ __webpack_exports__["Z"] = (_Button__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 64839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57107);
/* harmony import */ var _Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);








var Loader = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(function(_param) {
    var className = _param.className, size = _param.size, color = _param.color, type = _param.type, isError = _param.isError, isCompleted = _param.isCompleted, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "size",
        "color",
        "type",
        "isError",
        "isCompleted"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().loader), className, size, color, type)
    }, props), {
        children: [
            !isError && !isCompleted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().spinner)
            }),
            isCompleted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().checkmark))
            }),
            isError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().error))
            })
        ]
    }));
});
Loader.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    isCompleted: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    isError: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool)
};
Loader.defaultProps = {
    isCompleted: false,
    color: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blue)
};
Loader.Color = {
    WHITE: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().white),
    BLUE: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().blue)
};
Loader.Size = {
    LARGE: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().large),
    SMALL: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().small)
};
Loader.Type = {
    INLINE: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inline),
    FULL: (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default().full)
};
Loader.Styles = (_Loader_module_scss__WEBPACK_IMPORTED_MODULE_6___default());
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 80220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64839);

/* harmony default export */ __webpack_exports__["Z"] = (_Loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 84585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85034);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _hiredigital_ui_Loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80220);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);




var LoadingArea = function(param) {
    var height = param.height, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            height: "".concat(height, "px"),
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }, style),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            color: _hiredigital_ui_Loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Color.BLUE */ .Z.Color.BLUE,
            type: _hiredigital_ui_Loader__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Type.FULL */ .Z.Type.FULL
        })
    });
};
LoadingArea.propTypes = {
    height: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
    ]),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingArea);


/***/ }),

/***/ 77236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_Logo; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../@hiredigital/ui/src/Logo/Logo.module.scss
var Logo_module = __webpack_require__(20110);
var Logo_module_default = /*#__PURE__*/__webpack_require__.n(Logo_module);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Logo/svg/hd.inline.svg
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgHdinline = function SvgHdinline(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 80"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    id: "logo",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M9.5652 61.913V35.8211h33.0435v26.092h9.5652V0h-9.5652v26.9764H9.5652V0H0v61.913zM70.9565 12.5217v-9.739h-9.7391v9.739zM70.2609 61.2174V19.4783h-9.0435v41.739z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M96.9292 18.7826c1.8073 0 3.4575.2998 4.9507.8992l.382.1615-.112.0783c-1.0381.7395-2.0134 1.5938-2.926 2.5628-1.3376 1.4206-2.443 2.9609-3.3147 4.6197l.0868.033c-.796-.3092-1.6795-.4637-2.6507-.4637-2.031 0-3.6587.6283-4.8832 1.885-1.1565 1.1869-1.7669 2.7517-1.8311 4.6945l-.0057.3468v27.6177h-9.408v-41.558h9.408v6.0495l.1208-.3112c1.7685-4.41 5.1629-6.615 10.1831-6.615zM118.8264 18.7826c5.4375 0 9.8917 1.6589 13.3625 4.9766 3.4708 3.3177 5.2061 7.7414 5.2061 13.2709 0 1.2935-.1142 2.7019-.3427 4.2253l-.0911.5767h-29.0678l.0043.412c.081 3.8138 1.2943 6.7322 3.64 8.7554 2.5453 2.0372 5.4376 3.0558 8.677 3.0558 5.9592 0 9.6355-2.8015 11.0286-8.4045l.0779-.3264 7.8092 3.0558-.1412.4132c-3.0625 8.7464-9.3496 13.1196-18.8613 13.1196-6.363 0-11.5114-1.979-15.445-5.937-3.9335-3.958-5.9003-9.2546-5.9003-15.8901 0-6.0534 1.8656-11.1173 5.5966-15.1917 3.7311-4.0744 8.5468-6.1116 14.4472-6.1116zm-.0868 7.8578c-2.8345 0-5.2496.8149-7.2453 2.4446-1.9089 1.559-3.09 3.6504-3.5436 6.2744l-.0573.361h20.3908l.0868-.7857-.005-.331c-.0746-2.405-.9696-4.3172-2.6848-5.737-1.7933-1.4842-4.1071-2.2263-6.9416-2.2263zM189.6416 0l.5609.0032c9.4941.109 16.8948 2.9972 22.2022 8.6646 5.4113 5.7786 8.117 13.3556 8.117 22.731 0 8.9626-2.7498 16.289-8.2494 21.979-5.3896 5.5764-12.7422 8.4203-22.058 8.5318l-.5727.0034h-23.3807V0h23.3807zm0 8.8447H175.966v44.2236h13.6755c6.5877 0 11.7638-2.0785 15.5283-6.2355 3.7644-4.157 5.6466-9.3017 5.6466-15.434 0-6.722-1.8528-12.1615-5.5584-16.3186-3.6152-4.0556-8.658-6.1329-15.1286-6.2318l-.488-.0037zM234.4348 12.5217v-9.739h-9.7391v9.739zM234.4348 61.2174V19.4783h-9.0435v41.739zM258.5 18.7826c5.8142 0 10.1665 2.0818 13.0569 6.2454l.204.301v-5.6617h9.2826v38.3935l-.0041.5475c-.0955 6.3517-1.8623 11.4771-5.3003 15.3761C272.203 77.9948 267.1932 80 260.7101 80c-10.2157 0-16.8016-4.233-19.7574-12.699l-.1339-.3937 8.3986-3.5386.0926.3818c.6777 2.6433 1.9729 4.6687 3.8857 6.076 2.0038 1.4745 4.5086 2.2117 7.5144 2.2117 7.2572 0 10.94-4.378 11.0483-13.134l.0025-.401v-4.4233l-.173.35c-1.1283 2.192-2.8682 3.9184-5.2198 5.179-2.4753 1.327-5.3927 1.9905-8.7522 1.9905-5.4222 0-9.9456-1.9167-13.5702-5.7502-3.6247-3.8335-5.437-8.8464-5.437-15.039 0-6.4284 1.9155-11.7067 5.7464-15.835 3.8309-4.1284 8.5459-6.1926 14.1449-6.1926zm1.5029 7.9618c-3.5362 0-6.4389 1.2827-8.708 3.8482-2.269 2.5655-3.4036 5.9714-3.4036 10.2177 0 3.8924 1.1345 7.0034 3.4036 9.333 2.2691 2.3295 5.1718 3.4943 8.708 3.4943 3.4773 0 6.3652-1.2385 8.6638-3.7155 2.2985-2.595 3.4478-5.8092 3.4478-9.6426 0-3.8925-1.1493-7.1214-3.4478-9.6869-2.2986-2.5655-5.1865-3.8482-8.6638-3.8482zM299.1304 12.5217v-9.739h-9.7391v9.739zM298.4348 61.2174V19.4783h-9.0435v41.739zM325.336 61.913c4.007 0 7.2627-1.1539 9.767-3.4618 2.5044-2.3079 3.9628-5.536 4.3753-9.6843l-8.839-1.7529c-.3535 4.6742-2.2686 7.0113-5.7452 7.0113-1.532 0-2.799-.4966-3.8007-1.4899-1.0017-.9932-1.5026-2.3955-1.5026-4.2067V27.3824h17.3013v-7.8877h-17.3013V6.2609H310.31v13.2338h-8.397v7.8877h8.397v20.508c0 4.3821 1.2816 7.8147 3.8449 10.2979s6.2903 3.7247 11.1812 3.7247zM360 18.7826c5.9108 0 10.461 1.4406 13.6505 4.3218 3.0929 2.7939 4.6862 6.696 4.7799 11.7065l.0044.473V61.04h-8.7785v-6.9846l-.1387.3376c-.9582 2.2293-2.5798 4.023-4.865 5.381-2.3995 1.4261-5.3841 2.1391-8.954 2.1391-3.6285 0-6.818-1.164-9.5686-3.4923-2.7506-2.3282-4.1259-5.384-4.1259-9.1674 0-4.3654 1.4485-7.6686 4.3454-9.9095 2.8969-2.241 6.7448-3.3614 11.5437-3.3614 2.414 0 4.6806.2445 6.7996.7336l.5743.1395 4.3892 1.0477v-3.0558l-.0046-.3317c-.0713-2.5206-.9622-4.52-2.6728-5.9982-1.785-1.5424-4.1113-2.3137-6.9789-2.3137-2.692 0-4.9306.7276-6.7155 2.1828-1.6957 1.3823-2.7972 3.2638-3.3046 5.6442l-.0751.38-8.3396-2.1827.1047-.4395c.9805-3.9258 3.0085-7.0534 6.0841-9.3827 3.1895-2.4155 7.2715-3.6233 12.246-3.6233zm-.6145 24.0972c-5.15 0-7.725 1.8335-7.725 5.5004 0 1.688.6583 3.0558 1.9751 4.1035 1.3168 1.0477 3.2334 1.5716 5.75 1.5716 3.1016 0 5.5889-.7713 7.4616-2.3137 1.7947-1.4782 2.7295-3.5043 2.8042-6.0783l.005-.3389v-.4365l-3.3359-.8731-.5003-.1296c-2.6374-.6703-4.7823-1.0054-6.4347-1.0054zM395.1304 61.913V0h-9.0434v61.913z"
  }))));
};

/* harmony default export */ var hd_inline = (SvgHdinline);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Logo/Logo.jsx








var Logo = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var className = _param.className, type = _param.type, _site = _param.site, site = _site === void 0 ? "1" : _site, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "type",
        "site"
    ]);
    var logoSize = site === "2" ? (Logo_module_default()).hdLogo : (Logo_module_default()).hdMarketingLogo;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(hd_inline, (0,_object_spread/* default */.Z)({
        className: classnames_default()(logoSize, className, type)
    }, props));
});
Logo.propTypes = {
    className: (prop_types_default()).string,
    type: (prop_types_default()).string
};
Logo.Type = {
    WHITE: (Logo_module_default()).white,
    BLACK: (Logo_module_default()).black,
    BLUE: (Logo_module_default()).blue,
    DARKBLUE: (Logo_module_default()).darkblue,
    DARKGRAY: (Logo_module_default()).darkgray
};
/* harmony default export */ var Logo_Logo = (Logo);

;// CONCATENATED MODULE: ../@hiredigital/ui/src/Logo/index.jsx

/* harmony default export */ var src_Logo = (Logo_Logo);


/***/ }),

/***/ 10966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _Text_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65119);
/* harmony import */ var _Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Text_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







var Text = function(_param) {
    var Elem = _param.element, children = _param.children, size = _param.size, color = _param.color, type = _param.type, className = _param.className, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "element",
        "children",
        "size",
        "color",
        "type",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Elem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().base), size, type, color, className)
    }, restProps), {
        children: children
    }));
};
Text.Styles = (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default());
Text.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    element: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)
};
Text.defaultProps = {
    element: "p",
    size: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().body),
    type: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().standard),
    color: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().black)
};
Text.Type = {
    PRIMARY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().primary),
    SECONDARY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().secondary),
    NORMAL: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().standard),
    WHITE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().white),
    PARAGRAPH: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().paragraph),
    CENTER: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().center)
};
Text.Color = {
    BLACK: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().black),
    BLUE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().blue),
    DARK_BLUE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().darkblue),
    BLOGBLUE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().blogBlue),
    WHITE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().white),
    GREY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().grey)
};
Text.Size = {
    HEADLINE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headline),
    SUBHEADLINE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subheadline),
    SUBHEADLINE_LARGE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subheadlineLarge),
    INTRO: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().intro),
    HEADING_TWO: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headingTwo),
    BODY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().body),
    SECTION_BODY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().sectionBody),
    DISPLAY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().display),
    HUGE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().huge),
    SUBHEAD: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subhead),
    BLOGHEAD: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().blogHead),
    H2: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().h2),
    H3: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().h3),
    H4: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().h4),
    H5: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_5___default().h5)
};
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 67999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__bffDC","isLoadingBtn":"Button_isLoadingBtn__UD1Te","loader":"Button_loader__ia5NH","blue":"Button_blue__nzlR3","darkblue":"Button_darkblue__I5PcB","lightGray":"Button_lightGray__lsYDo","gray":"Button_gray__Oeuee","white":"Button_white__FYFpu","blueOutline":"Button_blueOutline__9Pih0","whiteOutline":"Button_whiteOutline__uplzt","redOutline":"Button_redOutline__o0zpn","whiteBlueOutline":"Button_whiteBlueOutline__QKLGg","fullwidth":"Button_fullwidth__IyxlK","halfwidth":"Button_halfwidth__JeTJZ","large":"Button_large__R80KS","fullwidthLarge":"Button_fullwidthLarge__6mc3i"};

/***/ }),

/***/ 57107:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__hueJt","large":"Loader_large__UhUmT","small":"Loader_small__PAVRp","checkmark":"Loader_checkmark__k9dtj","error":"Loader_error__vuxqU","spinner":"Loader_spinner__0ZurH","spin":"Loader_spin__WFye1","white":"Loader_white__7EaIQ","blue":"Loader_blue__BHJMn","full":"Loader_full__Ny1lE","container":"Loader_container__3y_rb"};

/***/ }),

/***/ 20110:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"Logo_white__2FS58","black":"Logo_black__xtvn6","blue":"Logo_blue__YOWB7","darkblue":"Logo_darkblue__A6hw6","darkgray":"Logo_darkgray__LkEBt","logo":"Logo_logo__lurSD","hdLogo":"Logo_hdLogo__WfXcv","hdMarketingLogo":"Logo_hdMarketingLogo__Uhg70"};

/***/ }),

/***/ 65119:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"base":"Text_base__0ik6d","display":"Text_display__51_no","headline":"Text_headline__ABAjm","subheadlineLarge":"Text_subheadlineLarge__CvyEY","subheadline":"Text_subheadline___mKuy","huge":"Text_huge__Z2Um1","intro":"Text_intro__ayrVT","headingTwo":"Text_headingTwo__lCj6d","sectionBody":"Text_sectionBody__Kmtrt","blogHead":"Text_blogHead__JZpBL","subhead":"Text_subhead__Or9BF","body":"Text_body__ttb3d","white":"Text_white__rlV81","grey":"Text_grey__674CG","paragraph":"Text_paragraph___go_l","center":"Text_center__56hVb","black":"Text_black__2lqNZ","blue":"Text_blue__06Ccf","blogBlue":"Text_blogBlue__0OTBW","darkblue":"Text_darkblue__sp4Ux","primary":"Text_primary__NgXiy","secondary":"Text_secondary__Hy_eZ","h2":"Text_h2__DliZ8","h3":"Text_h3__ETOR6","h4":"Text_h4__kevji"};

/***/ }),

/***/ 26067:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"enterpriseCompany":"Hero_enterpriseCompany__VhEjx","newHero":"Hero_newHero__nZmzC","seo":"Hero_seo__gj9u2","profile":"Hero_profile__OqUYv","careers":"Hero_careers__hi_Mt","container":"Hero_container__ea4sb","creator":"Hero_creator__kTKyH","about":"Hero_about__sIKzt","contact":"Hero_contact__zszw4","referral":"Hero_referral__C3sfy","register":"Hero_register__SRgCV","waveContainer":"Hero_waveContainer___jSi2","companyRegister":"Hero_companyRegister__ZjaLG","login":"Hero_login__jfxws","talent":"Hero_talent__z_csS","client":"Hero_client__BJX0G","itemContainer":"Hero_itemContainer__UZkdW","angleLarge":"Hero_angleLarge__c8hbQ","angleLarge1":"Hero_angleLarge1__R_poH","angleRightLarge":"Hero_angleRightLarge__fpl5f","angleRightLarge1":"Hero_angleRightLarge1___YD4f","rightAngleLarge":"Hero_rightAngleLarge__6AHtd","rightAngleLarge1":"Hero_rightAngleLarge1__SNHhY","rightAngleLarge2":"Hero_rightAngleLarge2__GBobr","rightAngleLarge3":"Hero_rightAngleLarge3__DoqC7","containerContact":"Hero_containerContact__40tXM","main":"Hero_main__90XId","downloads":"Hero_downloads__8NLii","heroLeft":"Hero_heroLeft__1R_9s","heroRight":"Hero_heroRight__mft3L","enterprise":"Hero_enterprise__r5ShK","vertical":"Hero_vertical__2L9CH","large":"Hero_large__5N3Nw","newEnterprise":"Hero_newEnterprise__JyKD_","bridge":"Hero_bridge__ag_rM","engagement":"Hero_engagement__DHL9o","curveLightblue":"Hero_curveLightblue__0fJs_","bottom":"Hero_bottom__muPLf","bottomMain":"Hero_bottomMain__etTp0","center":"Hero_center__DiKI3","shadow":"Hero_shadow__wXPhK","cta":"Hero_cta__gH_bQ","blue":"Hero_blue__3ndKP","heroContainer":"Hero_heroContainer__TkRDR","heroCenter":"Hero_heroCenter__8GjV2","heroTitle":"Hero_heroTitle__9BmQf","heroDescription":"Hero_heroDescription__8BLb8","heroCta":"Hero_heroCta__dKxwE","heroBottom":"Hero_heroBottom__oizGH","splitHero":"Hero_splitHero__Au05Q"};

/***/ }),

/***/ 64781:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Styles_button__bo2Kx"};

/***/ }),

/***/ 65811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ruler":"Section_ruler__krkkN","anchor":"Section_anchor__X8Nz7","addMargin":"Section_addMargin__JdbFT","section":"Section_section___TusU","medium":"Section_medium__bdeco","large":"Section_large__7gWX1","innerContainerSection":"Section_innerContainerSection__bHwWP","container":"Section_container__TDOy0","splitContainer":"Section_splitContainer__0Ms_G","containerCircle":"Section_containerCircle__gi0lf","containerLightblue":"Section_containerLightblue__4p7ai","containerImageBlue":"Section_containerImageBlue__nYjFX","containerDarkblue":"Section_containerDarkblue__cuqXq","containerEnterpriseSplit":"Section_containerEnterpriseSplit__eC4gA","gridContainer":"Section_gridContainer__MoIvi","containerProfessionalSplit":"Section_containerProfessionalSplit__Ig_xj","containerEnterpriseFull":"Section_containerEnterpriseFull__x9BGw","containerPrimaryblue":"Section_containerPrimaryblue__V__GH","containerLightblueGradient":"Section_containerLightblueGradient__uGb8Q","containerPlainWhite":"Section_containerPlainWhite__MeaOU","leadgen":"Section_leadgen__uWGW5","image":"Section_image__O_Lv8","split":"Section_split___PqQa","splitContent":"Section_splitContent__4fB8y"};

/***/ }),

/***/ 71987:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMasonry_container__S1EHN","companyContainer":"UserMasonry_companyContainer__wEf0d","portfolioList":"UserMasonry_portfolioList__8PwJu","talentPortfolioList":"UserMasonry_talentPortfolioList__bTaVX","companyPortfolioList":"UserMasonry_companyPortfolioList__CNCGv","spacer":"UserMasonry_spacer__H0i9e","smallSpacer":"UserMasonry_smallSpacer__96ypC","talentPortfolioItem":"UserMasonry_talentPortfolioItem__dswFP","portfolioItem":"UserMasonry_portfolioItem__ef8Ml","scroll":"UserMasonry_scroll__SGRT2","removeScroll":"UserMasonry_removeScroll__rIy6Q","image":"UserMasonry_image__5ABLM","talentName":"UserMasonry_talentName__n1b3X","talentPrimarySkill":"UserMasonry_talentPrimarySkill__6VZo9","name":"UserMasonry_name__O8FnN","primarySkill":"UserMasonry_primarySkill__iCA1H","skills":"UserMasonry_skills__e_0_8","itemContainer":"UserMasonry_itemContainer__O8qko","rightAngleLarge":"UserMasonry_rightAngleLarge__2bKH5"};

/***/ }),

/***/ 3204:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(10719);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(82126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(12164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

}]);